'use strict';

module.exports = function isObject(x) {
	return !!x && (typeof x === 'function' || typeof x === 'object');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isObject.js
 ** module id = 51
 ** module chunks = 0
 **/